import { render, staticRenderFns } from "./TS02.vue?vue&type=template&id=70337a98&scoped=true&"
import script from "./TS02.vue?vue&type=script&lang=js&"
export * from "./TS02.vue?vue&type=script&lang=js&"
import style0 from "./TS02.vue?vue&type=style&index=0&id=70337a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70337a98",
  null
  
)

export default component.exports